export const LIMIT_FALLBACK_MAX = 8
export const ACCOUNT_LIMIT_MAX = 8
export const HOLDBACK_LIMIT_MAX = 8
export const HOLDBACK_COPY = 'Demo hold-back slots must be a whole number from 0 to 8.'
export const ACCOUNT_LIMIT_COPY = 'The per-account chat limit must be a whole number from 0 to 8, or empty to use the server setting.'

export const appLimitCopy = (max: number): string =>
  `The app-wide chat limit must be a whole number from 0 to ${max}, or empty to use the server setting.`

export const appLimitMaxOf = (served: number | null | undefined): number =>
  served != null && Number.isInteger(served) && served >= 0 ? served : LIMIT_FALLBACK_MAX

export const capacityNote = (max: number): string =>
  `The app-wide limit can go up to ${max} YouTube chats at once. The YouTube runaway alarm grows with the chats running, so raising this limit needs no alarm change.`

const inRange = (n: number, min: number, max: number): boolean =>
  Number.isInteger(n) && n >= min && n <= max

export const limitsError = (
  v: { holdback: number | null, appLimit: number | null, accountLimit: number | null },
  appMax: number
): string | null => {
  if (v.holdback == null || !inRange(v.holdback, 0, HOLDBACK_LIMIT_MAX)) return HOLDBACK_COPY
  if (v.appLimit != null && !inRange(v.appLimit, 0, appMax)) return appLimitCopy(appMax)
  if (v.accountLimit != null && !inRange(v.accountLimit, 0, ACCOUNT_LIMIT_MAX)) return ACCOUNT_LIMIT_COPY
  return null
}
